import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SocialAuthService, FacebookLoginProvider, GoogleLoginProvider, SocialUser } from "angularx-social-login";
import * as AWS from 'aws-sdk';

import { ActivatedRoute, Router } from '@angular/router';
import { MarketService } from '../shared/services/market.service';
import { scaleIn } from '../shared/animations/modal.animation';
import { Auth, Hub } from 'aws-amplify';
import { eventNames } from 'process';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  animations: [scaleIn]
})
export class HomeComponent implements OnInit {

  @Input() visible: boolean;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  public displayProperty = true;
  public displayViewMore = false;
  public displayFilters = false;
  public displayTier = false;
  public propertyDetail: any;
  public propertiesData: any;
  public defaultPropData: any;
  public imageBaseUrl = "https://ganisponsormarket-all-purpose.s3.amazonaws.com/";
  public isLoading: boolean;
  imageName = "1200px-SAFA_logo.svg.png";
  public searchText: any;
  public displaySearchText: any = "";
  public searching: boolean;
  public searchResults: boolean;
  public resultsValue: number;
  public queryArr = [];
  public categories = [];
  public newCategories: Array<{}>;
  public test: boolean;
  public pageName: string = "home";
  public user: any;
  public userGroup: string;
  public topHitsQuery: any;
  public nextSearches: any;
  displayReg: boolean;
  displayLogin: boolean;
  username: string;
  isHidden: boolean = true;
  public userLoggedOff: boolean = true;
  public isButtonLoading: boolean;
  public showAllButton: boolean = true;
  public showLessButton: boolean;
  public user_sub: any;
  public topEsPropertiesData;
  public testArray;
  public searchResultObj: any;
  social_user: SocialUser;
  loggedIn: boolean;
  toastr: any;
  fbConnected: boolean;
  fbBundledObj: boolean;

  gConnected: boolean;

  gUser: any;

  @Output() fbObject = new EventEmitter<boolean>();
  fbStatus: any;
  noProperty: boolean = false;

  defaultImage = '../../assets/images/logo_white.png';
  public p: any;  //used for pagination
  showPagination: boolean = false;

  constructor(private route: ActivatedRoute, private router: Router, private marketService: MarketService, private authService: SocialAuthService) {
    this.categories = [
      { id: 1, value: 'Arts', isSelected: false },
      { id: 2, value: 'Music', isSelected: false },
      { id: 3, value: 'Sport', isSelected: false },
      { id: 4, value: 'Conference & Seminars', isSelected: false },
      { id: 5, value: 'Nature and Wildlife', isSelected: false },
      { id: 6, value: 'School Sponsorships', isSelected: false },
      { id: 7, value: 'Food and lifestyle', isSelected: false },
      { id: 8, value: 'Festival', isSelected: false },
      { id: 9, value: 'Fairs', isSelected: false },
      { id: 10, value: 'Bespoke Event', isSelected: false },
      { id: 11, value: 'Awards', isSelected: false }
    ];

    this.getCurrentAuthenticatedUser();
    // this.checkUserOnCognito(); 
    // this.getTopSearches();
  }

  ngOnInit() {
    this.isLoading = true;
    this.searching = false;
    this.searchResults = false;
    this.searchText = '';
    this.displayProperty = true;
    this.fbConnected = true;

    this.getCurrentAuthenticatedUser();

    Auth.currentAuthenticatedUser({
      bypassCache: true,
    })
      .then((user) => console.log('Bypassed Cache User ==> ', user))
      .catch((err) => console.log('Bypassed Cache Error ==> ', err));

    Hub.listen("auth", (data) => {
      console.log("🚀 ~ file: App.js ~ line 28 ~ Hub.listen ~ data", data);
    });


    // var userPool = new AmazonCognitoIdentity.CognitoUserPool(data);

    // this.onSignIn(this.gUser); 

    // event.requestContext.identity.cognitoAuthenticationProvider

    // this.user = sessionStorage.getItem('CurrentAuthenticatedUser');
    // this.userGroup = sessionStorage.getItem('UserGroup');
    // console.log("sessionStorage  CurrentAuthenticatedUser", this.user);
    // console.log("User Group", this.userGroup);

    this.getTopSearches();

    //Social Users Objects
    this.authService.authState.subscribe((user: any) => {
      this.social_user = user;
      this.loggedIn = (user != null);
      console.log('Social user ::: ', this.social_user);
    });

    //FaceBook init 
    (window as any).fbAsyncInit = function () {
      FB.init({
        appId: '136299118493147',
        cookie: true,
        xfbml: true,
        version: 'v3.1'
      });

      FB.AppEvents.logPageView();

    };

    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

    console.log('Reloaded status ==> ', this.fbStatus)

  }

  onSignIn(googleUser) {
    var profile = googleUser.getBasicProfile();
    console.log("Google Email ==>> ", profile.getEmail());
  }

  onLoginWithFB() {
    // Auth.federatedSignIn({provider: 'Facebook'})
    console.log('onLoginWithFB() called !!!');
    // Auth.federatedSignIn('facebook', { token, expires_at }, user);  

  }

  redirectToPoolAOUTH() {
    this.router.navigateByUrl('https://stackoverflow.com/questions/65299183/auth-federatedsigninprovider-facebook-in-react-native-returns-error-oau')
  }

  submitLogin() {
    FB.login((response) => {
      console.log('Submitting ', response);
      console.log('Status ::: ', response.status);
      this.fbStatus = response.status;

      if (response.status === "connected") {
        this.fbConnected = false;
      }
      if (response.authResponse) {
        // this.toastr.successToastr('Login successful', 'Success');
        console.log('Login successful');

        // Add the Facebook access token to the Amazon Cognito credentials login map.
        // AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        //   IdentityPoolId: 'us-east-1:d3708511-4409-4327-be18-47452870133d',
        //   Logins: {
        //     'graph.facebook.com': response.authResponse.accessToken
        //   }
        // });

        // AWS.config.credentials.get(function () {
        //   // Access AWS resources here.
        // });
      }
      else {
        console.log('User Login Failed!')
        // this.toastr.errorToastr('User Login Failed !');
      }
    })
  }

  checkUserOnCognito() {
    console.log('CheckUserOnCognito() called !!!');
    const body = {
      email: "cherry@ganizaniconsultingservices.co.za"
    }

    console.log('This is the test  user from angualr ===>>>> ', body.email);
    this.marketService.onListCognitoUsers('cherry@ganizaniconsultingservices.co.za').subscribe((data) => {
      console.log("Cognito FB DATA ::: ", data);
    },
      (error) => {
        console.log('Error ::: ', error);
      })
  }



  signInWithGoogle(): void {
    this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
  }

  signInWithFB(): void {
    this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
  }

  signOutOfSocialProvider(): void {
    this.authService.signOut();
  }

  refreshToken(): void {
    this.authService.refreshAuthToken(GoogleLoginProvider.PROVIDER_ID);
  }

  getSocialAuthenticatedUser() {
    console.log('GETSOCIALAUTHENTICATEDUSER method called !!!');
    Auth.currentAuthenticatedUser().then((user) => {
      console.log('Social federated User ==> ', user);
    })
  };

  // getFBAccessToken() {
  //   console.log('FB access token Method called !!!'); 
  //   FB.login(function (response) {
  //     var accessToken = response.authResponse.accessToken;
  //     console.log('ACCESS TOKEN ==>>> ', accessToken); 
  //   })
  // }

  async getUser() {
    const user = await Auth.currentAuthenticatedUser();
    console.log('User || ==> ', user);

    // Hub.listen('auth', (data) => {
    //   console.log('Hub data ==> ', data); 
    // })
  }

  getCurrentAuthenticatedUser() {

    console.log('getCurrentAuthenticatedUser method called !!!!!!');
    Auth.currentAuthenticatedUser()
      .then((user) => {

        this.user = user;
        this.user_sub = user.attributes.sub;

        console.log('Federated User || ', this.user);

        this.username = user.attributes.name + " " + user.attributes.family_name;
        this.isHidden = false;
        this.userLoggedOff = false;

        this.userGroup = user.signInUserSession.accessToken.payload['cognito:groups'][0];
        console.log('Detailed user group data ==> ', user.signInUserSession.accessToken.payload['cognito:groups'][0]);
        console.log('header user', user);
        console.log('User SUB ::: ', this.user_sub);

      },
        (error) => {
          this.userLoggedOff = true;
          // console.log("authentication error", error);

          this.isHidden = true;
        });
  }

  getTopSearches() {

    var batchArray = [];
    var count = 0;

    setTimeout(() => {
      console.log('PROPERTIES DATA ::: ', this.topEsPropertiesData);
    }, 3000);

    console.log('PROPERTIES DATA ::: ', this.topEsPropertiesData);



    if (!this.isHidden) {
      this.topHitsQuery = {
        "query": {
          "match": {
            "status": "PUBLISHED"
          }
        },
        "size": 0,
        "aggs": {
          "topSearches": {
            "top_hits": {
              "size": 100
            }
          }
        }
      }
    } else {
      this.topHitsQuery = {
        "query": {
          "match": {
            "status": "PUBLISHED"
          }
        },
        "size": 0,
        "aggs": {
          "topSearches": {
            "top_hits": {
              "size": 3
            }
          }
        }
      }
    }

    this.marketService.onQuerySearch(this.topHitsQuery, this.pageName).subscribe((data) => {
      this.isLoading = false;
      // console.log("Top Hits", data.aggregations.topSearches.hits.hits);
      this.propertiesData = data.aggregations.topSearches.hits.hits;
      this.topEsPropertiesData = data.aggregations.topSearches.hits.hits

      console.log("SUB PROP ::::: ", this.propertiesData);
      console.log("this.user", this.user);

      if (this.propertiesData.length > 5) {
        this.showPagination = true;
      } else {
        this.showPagination = false;
      }

      var ownProperty: boolean = false;
      var propertyCheck: any = [];

      this.propertiesData.forEach(property => {
        if (this.user && property._source.sub === this.user.attributes.sub) {
          ownProperty = true;
        } else {
          ownProperty = false;
        }
        propertyCheck.push(ownProperty);
      });

      if (propertyCheck.includes(true)) {
        this.noProperty = false;
      } else {
        this.noProperty = true;
      }

      console.log("propertyCheck", propertyCheck);
      console.log("this.noProperty", this.noProperty);

      // this.propertiesData.array.forEach(element => {
      //   const data = {
      //     sub: element._source.sub
      //   }
      //   batchArray.push(data); 
      //   count++; 
      //   console.log('BATCH ARRAY :: ', batchArray); 
      // });

      // console.log('BATCH ARRAY :: ', batchArray); 

    }, (error) => {
      this.isLoading = false;
      console.log("Top Searches Error", error);
      this.noProperty = true;
    });


    // if(batchArray === this.user_sub) {
    //   this.marketService.onQuerySearch(this.topHitsQuery, this.pageName).subscribe((data) => {
    //     this.isLoading = false;
    //     console.log("Top Hits", data.aggregations.topSearches.hits.hits);
    //     this.propertiesData = data.aggregations.topSearches.hits.hits;
    //     console.log('elastic sub :: ', data.aggregations.topSearches.hits.hits);   
    //     // console.log("SUB PROP ::::: ", this.propertiesData); 

    //     this.propertiesData.array.forEach(element => {
    //       const data = {
    //         sub: element._source.sub
    //       }
    //       batchArray.push(data); 
    //       count++; 
    //     });

    //   },
    //     (error) => {
    //       console.log("Top Searches Error", error);

    //     })
    // }
    // else { 
    //   console.log('Fail to resolved TopSearch sub !!!'); 
    // }


  }

  onChecked(event: any) {

    if (this.userGroup === 'properties' || this.userGroup === 'sponsors') {
      this.isLoading = true;
      this.queryArr = this.createQueryArray(event);
      const sortQuery = {
        "query": {
          "bool": {
            "should": this.queryArr,
            "minimum_should_match": 1,
            "boost": 1.0
          }
        }
      }

      this.marketService.onQuerySearch(sortQuery, this.pageName).subscribe((data) => {
        this.isLoading = false;
        this.searching = false;

        if (this.queryArr.length === 0) {
          this.getTopSearches();
        }

        // console.log("Sorting ", data);
        this.propertiesData = data.hits.hits;
      },
        (error) => {
          this.isLoading = false;
          // console.log("Sorting error", error);
        });
    }
    else {
      // console.log('Not Allowed !!!'); 
      alert('Please Login to perform this action !');
    }


  }

  createQueryArray(event: any): any[] {
    if (!event.target.checked) {
      this.remove(event.target.value);
    } else {
      this.queryArr.push({ "match": { "propType": event.target.value } });
    }
    return this.queryArr;
  }

  remove(category: any) {
    if (this.queryArr !== null) {
      var size = this.queryArr.length;
      for (var x = 0; x < size; x++) {
        console.log("remove loop: ", this.queryArr[x]);
        if (this.queryArr[x].match.propType == category) {
          console.log("Remove: ", category);
          this.queryArr.splice(x, 1);
          break;
        }
      }
    }

    // console.log("queryArr: ", this.queryArr);

  }

  onView(source: any) {

    var myParams = {
      source: source,
      user: this.user
    };
    const queryParams = JSON.stringify(myParams);

    this.router.navigate(
      ['/home/view'],
      {
        relativeTo: this.route,
        queryParams: { queryParams },
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });
    // this.propertyDetail = source;
    // console.log("Clicked: ", this.propertyDetail);

    // this.displayViewMore = true;
  }

  onRegister() {
    this.router.navigateByUrl('/reg-page');
  }

  onFilter() {
    this.displayFilters = true;
  }

  getFilters($event) {
    this.newCategories = $event;
    // console.log("getFilters: ", this.newCategories);

    this.isLoading = true;
    this.queryArr = this.newCategories;

    const sortQuery = {
      "query": {
        "bool": {
          "should": this.queryArr,
          "minimum_should_match": 1,
          "boost": 1.0
        }
      }
    }

    this.marketService.onQuerySearch(sortQuery, this.pageName).subscribe((data) => {
      this.isLoading = false;
      this.searching = false;

      if (this.queryArr.length === 0) {
        this.getTopSearches();
      }

      // console.log("Sorting ", data);
      this.propertiesData = data.hits.hits;
    },
      (error) => {
        this.isLoading = false;
        // console.log("Sorting error", error);
      });
  }



  onQuerySearch() {

    var batchArray = [];
    var count = 0;

    const myQuery = {
      "query": {
        "multi_match": {
          "query": this.searchText,
          "fields": ["name^1", "propDescription"]
        }
      }
    }

    this.displaySearchText = this.searchText;

    if (this.searchText.length !== 0) {
      this.isLoading = true;

      this.marketService.onQuerySearch(myQuery, this.pageName).subscribe((data) => {
        console.log("Search Results", data);
        //checking for error data

        this.searching = true;
        this.isLoading = false;

        this.propertiesData = data.hits.hits;
        this.resultsValue = data.hits.total.value;

        this.propertiesData.forEach((arrayData) => {
          const data = {
            sub: arrayData._source.sub
          }

          this.testArray = data;

          if (data.sub === undefined) {
            console.log('verification successful')
          }
          else {
            console.log('veriffication unsuccessful !!');
          }

          batchArray.push(data.sub);
          count++;
        })

        console.log('Attendance LOOP ::: ', batchArray);
        console.log('Att single ::: ', this.testArray.sub);
        // this.searchResultObj = this.searchResults.hits.hits; 

        // if(this.testArray.sub === this.user_sub) {
        //   console.log('Successful SUB verification'); 
        // }
        // else {
        //   console.log('Unsuccessful verification'); 
        // }



        if (this.resultsValue > 0) {
          this.searchResults = true;
        } else {
          this.searchResults = false;
        }

        console.log("searchResults", this.searchResults);

      },
        (error) => {
          this.isLoading = false;
          console.log("Search Error", error);
          this.propertiesData = [];                //Clear Array is no results found
        });
    } else {
      // console.log("Enter text in the search box");
      this.propertiesData = this.defaultPropData;
    }

    // if(batchArray === this.user_sub) {
    //   // console.log("Search word length: ", this.searchText.length);

    // // console.log("This is the search result : " + this.searchText);


    // // this.displaySearchResult = true;
    // // console.log("Search Word", this.searchText);
    // this.displaySearchText = this.searchText;

    // if (this.searchText.length !== 0) {
    //   this.isLoading = true;

    //   this.marketService.onQuerySearch(myQuery, this.pageName).subscribe((data) => {
    //     console.log("Search Results", data);
    //     //checking for error data

    //     this.searching = true;
    //     this.isLoading = false;

    //     this.propertiesData = data.hits.hits;
    //     this.resultsValue = data.hits.total.value;

    //     // console.log("Search Results value", this.resultsValue);
    //     if (this.resultsValue > 0) {
    //       this.searchResults = true;
    //     } else {
    //       this.searchResults = false;
    //     }

    //     // console.log("searchResults", this.searchResults);

    //   },
    //     (error) => {
    //       this.isLoading = false;
    //       console.log("Search Error", error);
    //       this.propertiesData = [];                //Clear Array is no results found
    //     });
    // } else {
    //   // console.log("Enter text in the search box");
    //   this.propertiesData = this.defaultPropData;
    // }
    // }
    // else {
    //   console.log('Error resolving SUb issue !!!'); 
    // }

  }

  onShowMore() {

    this.isButtonLoading = true;
    console.log('Show More button clicked...');
    this.topHitsQuery = {
      "query": {
        "match_all": {}
      },
      "size": 0,
      "aggs": {
        "topSearches": {
          "top_hits": {
            "size": 100
          }
        }
      }
    }

    this.marketService.onQuerySearch(this.topHitsQuery, this.pageName).subscribe((data) => {
      this.isButtonLoading = false;
      this.showAllButton = false;

      console.log("Top Hits", data.aggregations.topSearches.hits.hits);
      this.propertiesData = data.aggregations.topSearches.hits.hits;
      console.log('15 items on display!!');

    },
      (error) => {
        console.log("Top Searches Error", error);

      })
    // if(this.user_sub === this.propertiesData._source.sub) {

    // }
    // else {
    //   console.log('Failed to resolve SUB issue !!!'); 
    // }



  }

  onSearch() {

    this.searching = true;
    // console.log("Search Word", this.searchText);
    this.displaySearchText = this.searchText;

    this.marketService.onSearch(this.searchText).subscribe((data) => {
      // console.log("Search Results", data);

      this.propertiesData = data.hits.hits;
      this.resultsValue = data.hits.total.value;

      // console.log("Search Results value", this.resultsValue);
      if (this.resultsValue > 0) {
        this.searchResults = true;
      } else {
        this.searchResults = false;
      }

      // console.log("searchResults", this.searchResults);

    },
      (error) => {
        // console.log("Search Error", error);

      });
  }

  onDisplayTier() {
    this.displayTier = true;
  }

  onTestAuthUser() {
    const user = Auth.currentAuthenticatedUser()
      .then((user) => {
        // console.log('Detailed user settings data ==> ', user.signInUserSession.accessToken.payload['cognito:groups'][0]);
        // this.userAccessLevel = user.signInUserSession.accessToken.payload['cognito:groups'][0]; 
        // if(user.signInUserSession.accessToken.payload['cognito:groups'][0] === 'sponsors'){ 
        //   this.isHidden = false; 
        //   console.log(' oncheck access level is => ', this.isPropertyOwner); 
        // }
        // else {
        //   this.isHidden = true; 
        //   console.log('checking level of access is really => ', this.isPropertyOwner); 
        // }
      });
  }

  viewSignUp() {
    this.displayReg = true;
  }

  viewSignIn() {
    this.displayLogin = true;
  }

  closeForms($event) {
    this.displayLogin = false;
    this.displayReg = false;
  }

}